import React from 'react';
import Input from '../../../components/ui/Input';

const PhoneInput = ({ value, onChange, error, disabled }) => {
  const handlePhoneChange = (e) => {
    let phoneValue = e?.target?.value?.replace(/\D/g, '');

    // Ensure it starts with 98 (Iran country code)
    if (phoneValue && !phoneValue?.startsWith('98')) {
      phoneValue = '98' + phoneValue;
    }

    // Limit to 12 digits (98 + 10 digits)
    if (phoneValue?.length > 12) {
      phoneValue = phoneValue?.slice(0, 12);
    }

    onChange(phoneValue);
  };

  const formatDisplayValue = (phone) => {
    if (!phone) return '';

    // Add + prefix for display
    let formatted = '+' + phone;

    // Format as +98 912 000 0000
    if (phone?.length > 2) {
      formatted = `+${phone?.slice(0, 2)} ${phone?.slice(2)}`;
    }
    if (phone?.length > 5) {
      formatted = `+${phone?.slice(0, 2)} ${phone?.slice(2, 5)} ${phone?.slice(
        5
      )}`;
    }
    if (phone?.length > 8) {
      formatted = `+${phone?.slice(0, 2)} ${phone?.slice(2, 5)} ${phone?.slice(
        5,
        8
      )} ${phone?.slice(8)}`;
    }

    return formatted;
  };

  return (
    <div className="space-y-2">
      <Input
        type="tel"
        label="شماره موبایل"
        placeholder="+98 912 000 0000"
        value={formatDisplayValue(value)}
        onChange={handlePhoneChange}
        error={error}
        disabled={disabled}
        required
        className="text-left"
        dir="ltr"
      />
      <p className="text-sm text-muted-foreground">
        شماره موبایل خود را با کد کشور ایران وارد کنید
      </p>
    </div>
  );
};

export default PhoneInput;
